import { __extends } from "tslib";
import { ShaderDefineExpression } from "../shaderDefineExpression";
/** @hidden */
var ShaderDefineIsDefinedOperator = /** @class */ (function (_super) {
    __extends(ShaderDefineIsDefinedOperator, _super);
    function ShaderDefineIsDefinedOperator(define, not) {
        if (not === void 0) { not = false; }
        var _this = _super.call(this) || this;
        _this.define = define;
        _this.not = not;
        return _this;
    }
    ShaderDefineIsDefinedOperator.prototype.isTrue = function (preprocessors) {
        var condition = preprocessors[this.define] !== undefined;
        if (this.not) {
            condition = !condition;
        }
        return condition;
    };
    return ShaderDefineIsDefinedOperator;
}(ShaderDefineExpression));
export { ShaderDefineIsDefinedOperator };
//# sourceMappingURL=shaderDefineIsDefinedOperator.js.map